import React from 'react'

export default function Row({ className = '', ...props }) {
  return <div {...props} className={`${className} row`} />
}
